<template>
  <button
    type="button"
    class="btn btn-link btn-sm"
    @click="onClickAdd"
  >
    <span class="icon-wrapper">
      <x-icon icon="far fa-bell" />
      <x-icon
        v-if="localHasUnread"
        icon="fas fa-circle"
        class="badge-icon text-danger"
      />
    </span>
  </button>
</template>

<script setup>
import { ref } from 'vue'
import Messages from '@provise/views/messages/list.vue'
import { useModalStack } from '@provise/stores/modalstack'
import { useIntervalFn } from '@vueuse/core'
import { useApi } from '@provise/composables/api'
import config from '@/config'

const interval = Number(config.VITE_STATUS_INTERVAL ?? 30000)
const { model: hasUnread, refresh: rawRefresh } = useApi({
  url: 'current_status',
  pick: d => d.has_unread,
})
const localHasUnread = ref(false)

const refresh = async () => {
  await rawRefresh()
  localHasUnread.value = !!hasUnread.value
}
if (interval > 0) {
  useIntervalFn(refresh, interval, { immediate: true, immediateCallback: true })
}
const { push: openModal } = useModalStack()

function onClickAdd() {
  openModal({
    component: Messages,
    props: {
      class: 'modal-messages',
      headerText: 'Список сообщений',
      localHasUnread,
    },
  })
}
</script>
